exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "faqlanding .right-side_container{margin-top:3vh}faqlanding .right-side_container .left{float:left;width:16%}faqlanding .right-side_container .right{float:left;width:83%;font-size:1.72vw}faqlanding .right-text,faqlanding .right-text1{font-size:1.3vw;font-weight:500}faqlanding .right-text{padding-top:3vh}faqlanding .right-text .right-text-blue{color:#f1f1f1;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/landingpage/faqlanding/faqlanding.scss
// module id = 172
// module chunks = 0